document.addEventListener("DOMContentLoaded", () => {
  const toggles = document.querySelectorAll(".accordion-toggle");
  toggles.forEach((toggle) => {
    toggle.addEventListener("click", () => {
      const content = toggle.nextElementSibling;
      const isExpanded = toggle.getAttribute("aria-expanded") === "true";
      toggle.setAttribute("aria-expanded", !isExpanded);
      content.style.display = isExpanded ? "none" : "block";
      toggle.querySelector(".accordion-icon").textContent = isExpanded
        ? "+"
        : "−";
    });
  });

  const swiper = new Swiper(".swiper", {
    // Optional parameters
    direction: "horizontal",
    spaceBetween: 0,
  });

  const galleryImages = document.querySelectorAll(
    ".product-gallery-image-container"
  );
  Array.from(galleryImages).forEach((image) => {
    image.addEventListener("click", () => {
      const index = image.getAttribute("data-index");
      console.log(index);
      swiper.slideTo(index, 200, false);
    });
  });
});
